import { createAction } from '@ngrx/store';

export const login = createAction('[User Component] login');
export const logout = createAction('[User Component] logout');
